import { motion } from 'framer-motion'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import token from '../../assets/svgs/token.png'
import useAnimation from '../../utils/hooks/useAnimation'
import styles from './Token.module.scss'

const Token = ({ ownedTokens, size = 'small' }) => {
  const { t } = useTranslation()
  const [animate, trigger] = useAnimation({ scale: 1.3 })

  useEffect(() => {
    trigger()
  }, [ownedTokens, trigger])

  function svgSize() {
    let width
    let height
    if (size === 'small') {
      height = '41'
      width = '43'
    } else if (size === 'medium') {
      height = '75.81'
      width = '80'
    }
    return { width, height }
  }

  return (
    <>
      <motion.div
        className={`${styles.wrapper} ${styles[size]}`}
        initial={{ opacity: 0, scale: 0.2 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.2 }}
        transition={{ type: 'spring' }}
      >
        <div className={styles.banner}>
          <p className="sr-only">{t('common:token:noOfTokens')}</p>
          <motion.span animate={animate} className={styles.tokenWrapper}>
            {ownedTokens}
          </motion.span>
        </div>
        <motion.div
          animate={animate}
          transition={{ type: 'spring', delay: 0.4 }}
          className={styles.image}
        >
          <img src={token} alt="Token" {...svgSize()} />
        </motion.div>
      </motion.div>
    </>
  )
}

export default Token
